import { useQuery } from '@apollo/client';
import { FindHuddlesQuery, FindHuddlesQueryVariables, HuddleStatus, User } from 'lib/generated/graphql';
import { FIND_HUDDLES } from 'lib/queries';
import React, { useState } from 'react';
import HuddlesContainer, { MyHuddlesMap } from 'src/screens/my-projects/components/HuddlesContainer';
import RecommendedHuddles from 'src/screens/my-projects/components/Recommended';

const Builder = ({ user }: { user: User }) => {
  const { TeamForming, LiveProject, PastProject } = HuddleStatus;

  const { data: liveProjectdata } = useQuery<FindHuddlesQuery, FindHuddlesQueryVariables>(FIND_HUDDLES, {
    variables: {
      where: {
        status: { equals: LiveProject },
        builders: { some: { userId: { equals: user?.id } } },
      },
    },
  });

  const { data: optInData } = useQuery<FindHuddlesQuery, FindHuddlesQueryVariables>(FIND_HUDDLES, {
    variables: {
      where: {
        optIns: { some: { userId: { equals: user?.id } } },
        proposal: { some: { selectedOptIns: { none: { userId: { equals: user?.id } } } } },
      },
    },
  });

  const { data: selectedData } = useQuery<FindHuddlesQuery, FindHuddlesQueryVariables>(FIND_HUDDLES, {
    variables: {
      where: {
        status: { equals: TeamForming },
        proposal: { some: { selectedOptIns: { some: { userId: { equals: user?.id } } } } },
      },
    },
  });

  const { data: pastProjectData } = useQuery<FindHuddlesQuery, FindHuddlesQueryVariables>(FIND_HUDDLES, {
    variables: {
      where: {
        builders: { some: { userId: { equals: user?.id } } },
        status: { equals: PastProject },
      },
    },
  });

  const optedInHuddles = optInData?.findHuddles?.huddles || [];
  const selectedHuddles = selectedData?.findHuddles?.huddles || [];
  const liveHuddles = liveProjectdata?.findHuddles?.huddles || [];
  const pastHuddles = pastProjectData?.findHuddles?.huddles || [];

  const [showOptedInHuddles, setShowOptedInHuddles] = useState(false);
  // Filter huddles based on 'Team_Forming' status and 'showOptedInHuddles' state
  const filteredOptedInHuddles = optedInHuddles.filter(huddle => huddle.status === TeamForming || showOptedInHuddles);

  return (
    <HuddlesContainer>
      <div className="">
        <p className="text-xl font-medium text-gray-600 mb-10">
          Wondering how payments work at Huddle? Check out the{' '}
          <a
            href="https://www.notion.so/huddleworks/Huddle-Member-FAQs-b6e0a7c046784ea990c06244fe8b201e#b31d45898f16426182914070d21bc852"
            rel="noreferrer"
            target="_blank"
            className="text-blue-600 underline"
          >
            Huddle Payments FAQ
          </a>
        </p>
      </div>
      {liveHuddles.length > 0 && (
        <>
          <h1 className="font-bold uppercase mt-7 text-xl">ACTIVE</h1>
          <h3 className="text-gray-400 mb-4">Huddles you&apos;re working on</h3>
          <MyHuddlesMap huddles={liveHuddles} count={liveProjectdata?.findHuddles?.count} />
        </>
      )}
      {selectedHuddles.length > 0 && (
        <>
          <h1 className="font-bold uppercase mt-7 text-xl">PENDING</h1>
          <h3 className="text-gray-400 mb-4">Huddles where you&apos;re on the proposal</h3>
          <MyHuddlesMap selected huddles={selectedHuddles} count={selectedData?.findHuddles?.count} />
        </>
      )}

      {optedInHuddles.length > 0 && (
        <>
          <div className="flex items-center">
            <div>
              <div className="flex">
                <h1 className="font-bold uppercase text-xl">MARKED INTERESTED</h1>
                <button onClick={() => setShowOptedInHuddles(!showOptedInHuddles)} className="text-blue-500 pl-2">
                  {showOptedInHuddles ? 'Hide' : 'Show All'}
                </button>
              </div>

              <h3 className="text-gray-400 mb-4">Huddles you&apos;ve expressed interest in</h3>
            </div>
            <div className="flex content-start uppercase"></div>
          </div>
          {showOptedInHuddles && (
            <MyHuddlesMap optedIn huddles={optedInHuddles} count={optInData?.findHuddles?.count} />
          )}
          {!showOptedInHuddles && (
            <MyHuddlesMap optedIn huddles={filteredOptedInHuddles} count={optInData?.findHuddles?.count} />
          )}
        </>
      )}

      {pastHuddles.length > 0 && (
        <>
          <h1 className="font-bold uppercase mt-7 text-xl">PAST</h1>
          <h3 className="text-gray-400 mb-4">Huddles that have wrapped up</h3>
          <MyHuddlesMap huddles={pastHuddles} count={pastProjectData?.findHuddles?.count} />
        </>
      )}
      <RecommendedHuddles />
    </HuddlesContainer>
  );
};

export default Builder;
